const GOOGLE_ADS_CONVERSION_ID = 'AW-16790830198';
const GOOGLE_ADS_CONVERSION_LABEL = 'AfSiCKr9x-IcEPb4vsY-';

type GoogleAdsGlobalState = typeof globalThis & {
  __verdeconfirmaGoogleAdsConfigured?: boolean;
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
};

function ensureGoogleAdsBootstrap(win: GoogleAdsGlobalState): void {
  win.dataLayer = win.dataLayer ?? [];
  win.gtag =
    win.gtag ??
    ((...args: unknown[]) => {
      win.dataLayer!.push(args);
    });

  if (win.__verdeconfirmaGoogleAdsConfigured) {
    return;
  }

  win.__verdeconfirmaGoogleAdsConfigured = true;
  win.gtag('config', GOOGLE_ADS_CONVERSION_ID);
}

export function trackGoogleAdsPageViewConversion(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const win = window as GoogleAdsGlobalState;

  ensureGoogleAdsBootstrap(win);
  win.gtag?.('event', 'conversion', {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`,
    value: 1.0,
    currency: 'BRL',
  });
}
